import {
  GET_SALESPUBLIC,
  GET_SALESPUBLIC_ONE,
  GET_SALESPUBLIC_SUCCESS,
  GET_SALESPUBLIC_FAIL,
  DELETE_SALESPUBLIC,
  DELETE_SALESPUBLIC_SUCCESS,
  DELETE_SALESPUBLIC_FAIL,
  UPDATE_SALESPUBLIC,
  UPDATE_SALESPUBLIC_SUCCESS,
  UPDATE_SALESPUBLIC_FAIL,
  ADD_NEW_SALESPUBLIC,
  ADD_SALESPUBLIC_SUCCESS,
  ADD_SALESPUBLIC_FAIL,
  SALESPUBLIC_LOADING,
  SALESPUBLIC_RESET,
} from "./actionType";

export const resetSalesPublicState = (actionType) => ({
  type: SALESPUBLIC_RESET,
  payload: { actionType },
});

export const getSalesPublicSuccess = (actionType, data) => ({
  type: GET_SALESPUBLIC_SUCCESS,
  payload: { actionType, data },
});

export const getSalesPublicFail = (actionType, error) => ({
  type: GET_SALESPUBLIC_FAIL,
  payload: { actionType, error },
});

export const getSalesPublic = data => ({
  type: GET_SALESPUBLIC,
  payload: data,
});

export const getSalesPublicOne = (data) => ({
  type: GET_SALESPUBLIC_ONE,
  payload: data,
});

export const getSalesPublicLoading = () => ({
  type: SALESPUBLIC_LOADING
});

export const deleteSalesPublic = data => ({
  type: DELETE_SALESPUBLIC,
  payload: data,
});

export const deleteSalesPublicSuccess = data => ({
  type: DELETE_SALESPUBLIC_SUCCESS,
  payload: data,
});

export const deleteSalesPublicFail = error => ({
  type: DELETE_SALESPUBLIC_FAIL,
  payload: error,
});

export const updateSalesPublic = data => ({
  type: UPDATE_SALESPUBLIC,
  payload: data,
});

export const updateSalesPublicFail = error => ({
  type: UPDATE_SALESPUBLIC_FAIL,
  payload: error,
});

export const updateSalesPublicSuccess = data => ({
  type: UPDATE_SALESPUBLIC_SUCCESS,
  payload: data,
});

export const addNewSalesPublic = data => ({
  type: ADD_NEW_SALESPUBLIC,
  payload: data,
});

export const addSalesPublicSuccess = data => ({
  type: ADD_SALESPUBLIC_SUCCESS,
  payload: data,
});

export const addSalesPublicFail = error => ({
  type: ADD_SALESPUBLIC_FAIL,
  payload: error,
});